import { WeekdayStr } from 'rrule';

export const FORM_ID = 'customRepeat-form';

export enum EndEnum {
  NotEnd = 'NotEnd',
  OnDate = 'OnDate',
  NumberOccurrences = 'NumberOccurrences',
}

export const EndMap = {
  [EndEnum.NotEnd]: 'calendar_recurrence_doesnt_end',
  [EndEnum.OnDate]: 'calendar_recurrence_ends_on_date',
  [EndEnum.NumberOccurrences]: 'calendar_recurrence_ends_after_occurrences',
};

export const DAYS_MAP: WeekdayStr[] = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
